var render = function render(){var _vm=this,_c=_vm._self._c;return _c('thead',{staticClass:"thead"},[_c('tr',_vm._l((_vm.headers.length),function(title,index){return _c('th',{key:title,attrs:{"width":_vm.headersWidth(index)}},[_vm._v(_vm._s(_vm.headers[title-1]))])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }